import { CheckBox } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import API from "api";
import { useState } from "react";
import { toast } from "react-toastify";

const StaffUserManagement = () => {
  
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [overwrite, setOverwrite] = useState(false);

  const addUser = async () => {
    console.log(email, password, name, overwrite);
    if (!email || !password || !name) {
      toast.error("All fields are required");
      return;
    }
    await API.Staff.addUser(email, password, name, overwrite).then(
      (res) => {
        toast.success("User added successfully");
      }
    ).catch((error) => {
      toast.error(error?.response?.data?.message || error.message);
    });
  }

  return (
    <Box sx={{
      display: "grid",
      placeItems: "center",
    }}>
      <Typography variant="h1">
        Staff User Management
      </Typography>
      <hr />
      <Typography variant="h3">
        Add User
      </Typography>

      <Stack direction="row" alignItems="center"><Typography>Name</Typography>   <input type="name" value={name} onChange={(e) => setName(e.target.value)} /></Stack>
      <Stack direction="row" alignItems="center"><Typography>Email</Typography> <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} /></Stack>
      <Stack direction="row" alignItems="center"><Typography>Password</Typography> <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} /></Stack>

      <Stack direction="row" alignItems="center"><input type="checkbox" checked={overwrite} onChange={(e) => setOverwrite(e.target.checked)} /><Typography>Overwrite</Typography></Stack>

      <button type="button" onClick={addUser}>Add</button>
    </Box>
  )
} 

export default StaffUserManagement;